<template>
  <v-dialog
    v-model="dialogHeslo"
    max-width="500px"
    transition="dialog-transition"
    v-if="dialogHeslo"
    persistent
  >
    <v-card class="no__padding">
      <v-card-title class="pa-0 justify-center" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
        <h2>Je vyžadována změna hesla</h2>
      </v-card-title>
      <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
        <v-form v-model="valid" lazy-validation ref="form">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                name="username"
                class="hidden"
                :value="me.prihlaseni_uzivatel"
              ></v-text-field>
              <v-text-field
                label="Staré heslo"
                :type="show1 ? 'text' : 'password'"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                @click:append="show1 = !show1"
                :rules="[ (e) => !!e || 'Staré heslo je vyžadováno' ]"
                v-model="stare_heslo_hodnota"
                v-if="stare_heslo"
              ></v-text-field>
              <v-text-field
                label="Nové heslo"
                :type="show2 ? 'text' : 'password'"
                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                @click:append="show2 = !show2"
                :rules="rules"
                v-model="nove_heslo"
              ></v-text-field>
              <v-text-field
                label="Nové heslo pro kontrolu"
                :type="show3 ? 'text' : 'password'"
                :append-icon="show3 ? 'visibility' : 'visibility_off'"
                @click:append="show3 = !show3"
                :rules="[ (e) => (!!e && nove_heslo_kontrola == nove_heslo) || 'Nové heslo pro kontrolu není stejné jako nové heslo' ]"
                v-model="nove_heslo_kontrola"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="error != null">
              <p class="red--text mt-3 mb-4 text-xs-center">
                {{error}}
              </p>
            </v-flex>
            <v-flex xs12>
              <p class="mt-3 mb-0 text-xs-center">
                <v-btn depressed dark color="orange" class="ma-0 bold" @click="passAccept" :loading="saving">Změnit heslo</v-btn>
              </p>
              <p class="mb-0 text-xs-center">
                <v-btn dark class="elevation-0 grey--text ma-0 mt-3 mb-4" flat @click="signout" v-if="!close">Odhlásit</v-btn>
                <v-btn dark class="elevation-0 grey--text ma-0 mt-3 mb-4" flat @click="closeClick" v-else>Zavřít</v-btn>
              </p>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogHeslo: true,
      valid: false,
      show1: false,
      show2: false,
      show3: false,
      stare_heslo_hodnota: null,
      nove_heslo: null,
      nove_heslo_kontrola: null,
      saving: false,
      error: null,
      rules: [
        function(e) {
          return (!!e && e.toString().length >= 6 && e != window.stare_heslo_hodnota) || 'Nové heslo je vyžadováno (nesmí být stejné jako staré), délka hesla musí být min. 6 pozic';
        }
      ]
    }
  },
  watch: {
    stare_heslo_hodnota (v) {
      window.stare_heslo_hodnota = v;
    }
  },
  props: {
    id: String,
    close: Boolean,
    value: Boolean,
    stare_heslo: Boolean,
  },
  computed: {
    me () {
      return window.$me;
    }
  },
  mounted: function() {
  },
  methods: {
    passAccept () {
      if (this.$refs.form.validate()) {
        if (window.testovaci_klient) {
          this.$emit("input", false);
        }
        else {
          this.saving = true;
          this.error = null;
          window.API.put("uzivatel/password", {
            "old": this.stare_heslo_hodnota,
            "new": this.nove_heslo,
          }).then(function(body) {
            if (body.updated) {
              if (this.close) {
                this.$emit("input", false);
              }
              else {
                this.dialogHeslo = false;
              }
            }
            else {
              this.saving = false;
              switch (body.message) {
                case "bad_old_password":
                  this.error = "Špatně zadané staré heslo.";
                  break;
                case "empty_password":
                  this.error = "Nové heslo musí být zadáno.";
                  break;
                default:
                  this.error = "Nové heslo nemohlo být změněno.";
                  break;
              }
            }
          }.bind(this)).catch(function(err) {
            console.log(err);
            this.saving = false;
          }.bind(this));
        }
      }
    },
    signout: function() {
      window.API.$setCookie("cc_eshop_uid", "", { expires: -30, path: "/" });
      window.API.$setCookie("cc_eshop_token", "", { expires: -30, path: "/" });
      window.location.reload();
    },
    closeClick () {
      this.$emit("input", false);
    }
  },
  components: {

  }
}
</script>
